(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auris-comparison"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('.auris-comparison [data-compare-option]');
    if (!tab) return;
    var root = tab.closest('.auris-comparison');
    var option = tab.dataset.compareOption;
    root.querySelectorAll('[data-compare-option]').forEach(function (button) {
      var active = button === tab;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    root.querySelectorAll('[data-compare-cell]').forEach(function (cell) {
      cell.classList.toggle('is-active', cell.dataset.compareCell === option);
    });
    var label = root.querySelector('[data-selected-label]');
    if (label) label.textContent = tab.textContent.trim();
  });

  } catch(e) { console.error(e); }
})();
})();
